import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import useUIEditor from 'assets/hooks/uiEditor/UIEditor';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { UICommand } from 'assets/utils/dom/Commands';

export default function ClaimEmailTemplateTags() {
  const { lang } = getLocales();
  const uiEditor = useUIEditor();
  return (
    <DropdownButton
      buttonMedia={<Icon class="fas-plus" />}
      buttonBody={lang.addPlaceholder}
      horizontalPosition="auto_fixed"
      verticalPosition="auto_fixed"
      tabIndex={null}
      htmlElementProps={{
        title: lang.addEmailTemplatePlaceholder,
      }}
      subcomponents={ThemeDropdownButtonPopup}
      dropdownOptions={
        <DataMap
          data={[
            { id: '{{IEmailTemplate_SenderName}}', title: lang.senderName },
            { id: '{{IEmailTemplate_SenderEmail}}', title: lang.senderEmail },
            { id: '{{Claim_ContactName}}', title: lang.contactName },
            { id: '{{Claim_ContactPhone}}', title: lang.phoneNumber },
            { id: '{{Claim_ContactEmail}}', title: lang.email },
            { id: '{{ClaimUrl}}', title: `${lang.claim} ${lang.url}` },
            { id: '{{ClaimPayee_Name}}', title: `${lang.claim} ${lang.payee} ${lang.contactName}` },
            { id: '{{ClaimPayee_PhoneNumber}}', title: `${lang.claim} ${lang.payee} ${lang.phoneNumber}` },
            { id: '{{ClaimPayee_Email}}', title: `${lang.claim} ${lang.payee} ${lang.email}` },
            { id: '{{Claim_Number}}', title: lang.claimNumber },
            { id: '{{Claim_WorkOrderNumber}}', title: lang.workOrderNumber },
            { id: '{{ClaimDetail_ClaimJobComments}}', title: lang.claimJobNotes },
            { id: '{{ClaimDetail_ClaimExternalComments}}', title: lang.claimExternalComments },
            { id: '{{ClaimDetail_ClaimJobDetails}}', title: `${lang.claimJob} ${lang.details}` },
            {
              id: '{{ClaimDetail_ClaimJobAggregateDetails}}',
              title: `${lang.claimJob} ${lang.aggregate}  ${lang.details}`,
            },
            { id: '{{ClaimAmount_TotalAmount}}', title: lang.claimTotalAmount },
            { id: '{{ClaimAmount_TotalTaxAmount}}', title: lang.claimTotalTaxAmount },
            { id: '{{ClaimAmount_TotalAmountWithTax}}', title: lang.claimTotalAmountWithTax },
            { id: '{{Contract_AppNumberWithRevision}}', title: lang.contractNumber },
            { id: '{{Dealer_Name}}', title: lang.dealer },
            { id: '{{Client_FirstName}} {{Client_LastName}}', title: lang.client },
            { id: '{{Vehicle_Vin}}', title: lang.vin },
            { id: '{{IClaimDocument_Name}}', title: `${lang.claim} ${lang.invoices}/${lang.documents} ${lang.name}` },
            { id: '{{IClaimDocument_Notes}}', title: `${lang.claim} ${lang.invoices}/${lang.documents} ${lang.notes}` },
            { id: '{{MediaFile_Url}}', title: `${lang.download} link` },
          ]}
          render={({ data }) => (
            <Button
              key={data.id}
              class={ThemeButtonMenuItem}
              render={data.title}
              onClick={(data) => uiEditor.applyUiCommand(UICommand.insertHTML, data)}
              data={data.id}
            />
          )}
        />
      }
    />
  );
}
